<template>
<div class="k-page-content">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="角色管理" name="first">
                <div class="k-page-common">
                    <div class="k-common-header">
                        <div class="k-filter-option k-filter-input" style="margin-bottom:0;">
                            <el-form :inline="true" :model="searchForm" size="mini" ref="searchForm" :rules="rules.searchForm">
                                <el-form-item label="查询类型" prop="type">
                                    <el-select v-model="searchForm.type" placeholder="请选择查询类型">
                                        <el-option label="角色名称" value="name"></el-option>
                                        <el-option label="角色等级" value="level"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="角色名称" prop="name" v-show="searchForm.type == 'name'">
                                    <el-input v-model="searchForm.name" placeholder="请填写角色名称"></el-input>
                                </el-form-item>
                                <el-form-item label="版本号" prop="level" v-show="searchForm.type == 'level'">
                                    <el-select v-model="searchForm.level" placeholder="请选择角色等级" clearable>
                                        <el-option label="一级分类" value="LEVEL_ONE"></el-option>
                                        <el-option label="二级分类" value="LEVEL_TWO"></el-option>
                                        <el-option label="三级分类" value="LEVEL_THREE"></el-option>
                                        <el-option label="四级分类" value="LEVEL_FOUR"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="doSearch">查询</el-button>
                                    <el-button type="primary" @click="reset">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="k-table-toolbar" style="margin-top:0;">
                                <div>
                                    <el-button type="primary" size="mini" @click="handelAddOpen">添加角色</el-button>
                                </div>
                            </div>
                            <div class="k-table-con">
                                <el-table
                                    :data="tableData.data"
                                    style="width: 100%"
                                    border
                                    stripe
                                    ref="table"
                                    highlight-current-row
                                    @sort-change="sortChange"
                                    :height="tableHeight">

                                <el-table-column
                                        fixed
                                        prop="name"
                                        label="角色名称"
                                        width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="level_text"
                                        label="等级分类"
                                        width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="status_text"
                                        label="角色状态"
                                        width="100">
                                </el-table-column>
                                <el-table-column
                                        prop="create_time"
                                        label="创建时间"
                                        width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        prop="update_time"
                                        label="修改时间"
                                        width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        fixed="right"
                                        label="操作"
                                        min-width="200">
                                    <template slot-scope="scope">
                                        <el-button @click="handleTableMenusOpen(scope.row)" type="text" size="small">菜单</el-button>
                                        <el-button @click="handleTableActionsOpen(scope.row)" type="text" size="small">功能
                                        </el-button>
                                        <el-button @click="handleTableEditOpen(scope.row)" type="text" size="small">编辑</el-button>
                                        <el-button @click="handleTableDelete(scope.row)" type="text" size="small" class="c-danger">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>

                            </el-table>
                            <el-pagination
                                background
                                ref="pagination"
                                @current-change="handleCurrentChange"
                                :current-page="tableData.current_page | number"
                                :page-size="tableData.per_page | number"
                                layout="total, prev, pager, next, jumper"
                                :total="tableData.total | number">
                            </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="addFormVisiable"
        direction="rtl"
        size="40%">
        <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px">
            <div class="drawer-header">
                <div class="header-title">
                    <span>添加角色</span>
                    <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
                <el-form-item label="角色名称" prop="name">
                    <el-input v-model="addForm.name" placeholder="请填写角色名称"></el-input>
                </el-form-item>

                <el-form-item label="角色等级" prop="level">
                    <el-select v-model="addForm.level" placeholder="请选择角色等级">
                        <el-option label="一级分类" value="LEVEL_ONE"></el-option>
                        <el-option label="二级分类" value="LEVEL_TWO"></el-option>
                        <el-option label="三级分类" value="LEVEL_THREE"></el-option>
                        <el-option label="四级分类" value="LEVEL_FOUR"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否开启" prop="status">
                    <el-radio v-model="addForm.status" label="STATUS_NORMAL">正常</el-radio>
                    <el-radio v-model="addForm.status" label="STATUS_CLOSE">关闭</el-radio>
                </el-form-item>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="handelAdd" :size='size'>提交</el-button>
                <el-button :size='size' @click="addFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
    
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="editFormVisiable"
        direction="rtl"
        size="40%">
        <el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px">
            <div class="drawer-header">
                <div class="header-title">
                    <span>编辑角色</span>
                    <i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
                <el-form-item label="角色名称" prop="name">
                    <el-input v-model="editForm.name" placeholder="请填写角色名称"></el-input>
                </el-form-item>

                <el-form-item label="角色等级" prop="level">
                    <el-select v-model="editForm.level" placeholder="请选择角色等级">
                        <el-option label="一级分类" value="LEVEL_ONE"></el-option>
                        <el-option label="二级分类" value="LEVEL_TWO"></el-option>
                        <el-option label="三级分类" value="LEVEL_THREE"></el-option>
                        <el-option label="四级分类" value="LEVEL_FOUR"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否开启" prop="status">
                    <el-radio v-model="editForm.status" label="STATUS_NORMAL">正常</el-radio>
                    <el-radio v-model="editForm.status" label="STATUS_CLOSE">关闭</el-radio>
                </el-form-item>
    
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="handleTableEdit" :size='size'>提交</el-button>
                <el-button :size='size' @click="editFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
    
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="menusFormVisiable"
        direction="rtl"
        size="70%">
        <el-form :model="menusForm" :size="size" label-width="80px">
            <div class="drawer-header">
                <div class="header-title">
                    <span>为角色分配菜单权限</span>
                    <i class="el-icon-close k-drawer-close" @click="menusFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
                <el-button type="text" @click="handleTableSlectAll('menusForm')">全选</el-button>
                <el-button type="text" @click="handleTableCancelAll('menusForm')">全不选</el-button>
                <el-button type="text" @click="handleTableSelectChange('menusForm')">反选</el-button>
                <el-main :style="apiMainHeight">

                    <el-form-item v-if="item.has_children" :label="item.name" prop="privileges" :key="index"
                                    v-for="(item, index) in options.menus">
                        <el-checkbox-group v-model="menusForm.privileges">
                            <el-checkbox :label="value.privilege_id" :key="value.privilege_id"
                                            v-for="(value, key) in item.children">{{value.name}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                </el-main>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="handleTableMenus" :size='size'>提交</el-button>
                <el-button :size='size' @click="menusFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>

    <el-drawer
        custom-class="k-drawer"
        :visible.sync="actionsFormVisiable"
        direction="rtl"
        size="70%">
        <el-form :model="actionsForm" :size="size" label-width="80px">
            <div class="drawer-header">
                <div class="header-title">
                    <span>为角色分配功能权限</span>
                    <i class="el-icon-close k-drawer-close" @click="actionsFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
                <el-button type="text" @click="handleTableSlectAll('actionsForm')">全选</el-button>
                <el-button type="text" @click="handleTableCancelAll('actionsForm')">全不选</el-button>
                <el-button type="text" @click="handleTableSelectChange('actionsForm')">反选</el-button>
                <el-main :style="apiMainHeight">

                    <el-form-item v-if="item.has_children" :label="item.name" prop="privileges" :key="index"
                                    v-for="(item, index) in options.actions">
                        <el-checkbox-group v-model="actionsForm.privileges">
                            <el-checkbox :label="value.privilege_id" :key="value.privilege_id"
                                            v-for="(value, key) in item.children">{{value.name}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                </el-main>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="handleTableActions" :size='size'>提交</el-button>
                <el-button :size='size' @click="actionsFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
    
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
		  loading:false,
          actionsFormVisiable: false,
          menusFormVisiable: false,
          addFormVisiable: false,
          editFormVisiable: false,
          checkSkVisiable: false,
          activeName: 'first',
          size:'mini',
          options: {
              menus: [],
              actions: [],
          },
          searchForm: {
              type: 'name',
              name: '',
              level: '',
          },
          resetSearch: {
              type: 'name',
              name: '',
              level: '',
          },
          addForm: {
              name: '',
              level: 'LEVEL_ONE',
              status: 'STATUS_NORMAL',
          },
          editForm: {
              name: '',
              level: 'LEVEL_ONE',
              status: 'STATUS_NORMAL',
          },
          menusForm: {
              id: '',
              privileges: []
          },
          actionsForm: {
              id: '',
              privileges: []
          },
          checkSkForm: {
              id: '',
              secret_key: ''
          },
          checkSk: {
              show: false,
              text: '显示',
          },
          rules: {
              searchForm: {
                  'type': [
                      {required: true, message: '请选择搜索类型', trigger: ['change', 'blur']}
                  ],
                  'name': [
                      {max: 50, message: '请填写正确的角色名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
              },
              addForm: {
                  'name': [
                      {required: true, message: '请填写正确的角色名称，长度不超过 50', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的角色名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'level': [
                      {required: true, message: '请选择搜索角色等级', trigger: ['change', 'blur']}
                  ],
                  'status': [
                      {required: true, message: '请选择搜索角色状态', trigger: ['change', 'blur']}
                  ],
              },
              editForm: {
                  'name': [
                      {required: true, message: '请填写正确的角色名称，长度不超过 50', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的角色名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'level': [
                      {required: true, message: '请选择搜索角色等级', trigger: ['change', 'blur']}
                  ],
                  'status': [
                      {required: true, message: '请选择搜索角色状态', trigger: ['change', 'blur']}
                  ],
              }
          },
          tableData: {
              total: 0,
              per_page: 15,
              current_page: 1,
              last_page: 0,
              data: []
          }
      }
  },
  computed: {
      tableHeight: function () {
          return window.innerHeight - 320;
      },
      apiMainHeight: function () {
          var height = window.innerHeight - 200;
          return {height: height + 'px', border: '1px solid #DCDFE6', 'margin-bottom': '10px'}
      },
  },
  methods: {
      reset: function () {
          this.searchForm = this.resetSearch;
          this.doSearch();
      },
      handleSearch: function (params, page, prop, order) {
  
          this.$refs['searchForm'].validate(function (valid) {
  
              if (valid) {
                  this.loading = true;
  
                  var param = Object.assign({}, params);
  
                  param['page'] = page ? page : 1;
                  param['prop'] = prop ? prop : 'id';
                  param['order'] = order ? order : 'desc';
					this.$api.management.roleList(param).then(res=>{
						if (res.code === 0) {
						    this.tableData = res.data;
						  
						    this.$message({
						        showClose: true,
						        message: '查询应用列表信息成功！',
						        type: 'success'
						    });
						} else {
						    var message = '查询应用列表信息失败！';
						    if (res.message) {
						        message = res.message;
						    }
						    this.$message({
						        showClose: true,
						        message: message,
						        type: 'error'
						    });
						}
						this.loading = false
					})
  
              } else {
                  this.$message({
                      showClose: true,
                      message: '请填写正确的信息！',
                      type: 'warning'
                  });
              }
          }.bind(this));
      },
  
      // 执行查询
      doSearch: function (event) {
          var query = this.searchForm;
          query['_t'] = Date.parse(new Date());
          this.$router.push({path: this.$route.path, query: query});
      },
  
      // 排序
      sortChange: function (e) {
          var order;
          var prop = e.prop;
          if (e.order == 'ascending') {
              order = 'asc';
          } else if (e.order == 'descending') {
              order = 'desc';
          } else {
              prop = this.resetSearch.prop;
              order = this.resetSearch.order;
          }
          this.handleSearch(this.searchForm, 1, prop, order);
      },
  
      // 改变当前页 page
      handleCurrentChange: function (val) {
          this.handleSearch(this.searchForm, val);
      },
  
      // 添加角色
      handelAddOpen: function () {
          this.addFormVisiable = true;
      },
  
      // 全选
      handleTableSlectAll: function (form) {
  
          switch (form) {
              case 'menusForm':
                  var privileges = [];
                  var item;
                  for (var i in this.options.menus) {
                      item = this.options.menus[i];
  
                      for (var index in item.children) {
                          privileges.push(item.children[index].privilege_id);
                      }
  
                  }
                  this.menusForm.privileges = privileges;
                  break;
              case 'actionsForm':
                  var privileges = [];
                  var item;
                  for (var i in this.options.actions) {
                      item = this.options.actions[i];
  
                      for (var index in item.children) {
                          privileges.push(item.children[index].privilege_id);
                      }
  
                  }
                  this.actionsForm.privileges = privileges;
                  break;
          }
      },
  
      // 反选
      handleTableSelectChange: function (form) {
  
          switch (form) {
              case 'menusForm':
                  var privileges = [];
                  var item;
                  for (var i in this.options.menus) {
                      item = this.options.menus[i];
  
                      for (var index in item.children) {
                          if (this.menusForm.privileges.indexOf(item.children[index].privilege_id) < 0) {
                              privileges.push(item.children[index].privilege_id);
                          }
                      }
  
                  }
                  this.menusForm.privileges = privileges;
                  break;
              case 'actionsForm':
                  var privileges = [];
                  var item;
                  for (var i in this.options.actions) {
                      item = this.options.actions[i];
  
                      for (var index in item.children) {
                          if (this.actionsForm.privileges.indexOf(item.children[index].privilege_id) < 0) {
                              privileges.push(item.children[index].privilege_id);
                          }
                      }
  
                  }
                  this.actionsForm.privileges = privileges;
                  break;
          }
      },
  
      // 全不选
      handleTableCancelAll: function (form) {
  
          switch (form) {
              case 'menusForm':
                  this.menusForm.privileges = [];
                  break;
              case 'actionsForm':
                  this.actionsForm.privileges = [];
                  break;
          }
      },
  
      // 添加角色
      handelAdd: function () {
  
          this.$refs['addForm'].validate(function (valid) {
              if (valid) {
                  this.loading = true;
				  this.$api.management.roleAdd(this.addForm).then(res=>{
					  if (res.code === 0) {
					      this.tableData.data.unshift(res.data);
					      this.$message({
					          showClose: true,
					          message: '添加角色成功！',
					          type: 'success'
					      });
						  this.addFormVisiable = false;
					  } else {
					      var message = '添加角色失败！';
					    
					      if (res.message) {
					          message = res.message;
					      }
					    
					      this.$notify({
					          showClose: true,
					          message: message,
					          type: 'warning'
					      });
					  }
					  this.loading = false
				  })
  
              } else {
                  this.$message({
                      showClose: true,
                      message: '请填写正确的信息！',
                      type: 'warning'
                  });
              }
          }.bind(this));
      },
  
      // 打开编辑角色弹窗
      handleTableEditOpen: function (row) {
          this.loading = true;
		  this.$api.management.roleGet({id: row.id}).then(res=>{
			  if (res.code === 0) {
			      this.editForm = res.data;
			    
			      this.$message({
			          showClose: true,
			          message: '查询角色信息成功！',
			          type: 'success'
			      });
			      this.editFormVisiable = true;
			  } else {
			      var message = '查询角色信息失败！';
			    
			      if (res.message) {
			          message = res.message;
			      }
			    
			      this.$notify({
			          showClose: true,
			          message: message,
			          type: 'warning'
			      });
			  }
			  this.loading = false
		  })
      },
  
      // 编辑角色
      handleTableEdit: function () {
  
          this.$refs['editForm'].validate(function (valid) {
              if (valid) {
                  this.loading = true;
				  this.$api.management.roleEdit(this.editForm).then(res=>{
					  if (res.code === 0) {
					      var data = this.tableData.data;
					      data.forEach(function (item, index) {
					          if (item.id == res.data.id) {
					              this.$set(data, index, res.data);
					          }
					      }.bind(this));
					    
					      this.$message({
					          showClose: true,
					          message: '修改角色信息成功！',
					          type: 'success'
					      });
						  this.editFormVisiable = false;
					  } else {
					      var message = '修改角色信息失败！';
					    
					      if (res.message) {
					          message = res.message;
					      }
					    
					      this.$notify({
					          showClose: true,
					          message: message,
					          type: 'warning'
					      });
					  }
					  this.loading = false
				  })
  
              } else {
                  this.$message({
                      showClose: true,
                      message: '请填写正确的信息！',
                      type: 'warning'
                  });
              }
          }.bind(this));
      },
  
      // 打开编辑角色弹窗
      handleTableMenusOpen: function (row) {
          this.loading = true;
		  this.$api.management.roleMenus({id: row.id}).then(res=>{
			  if (res.code === 0) {
			      this.options.menus = res.data.menus;
			      this.menusForm.privileges = res.data.privileges;
			      this.menusForm.id = res.data.role.id;
			    
			      this.$message({
			          showClose: true,
			          message: '查询角色信息成功！',
			          type: 'success'
			      });
			      this.menusFormVisiable = true;
			  } else {
			      var message = '查询角色信息失败！';
			    
			      if (res.message) {
			          message = res.message;
			      }
			    
			      this.$notify({
			          showClose: true,
			          message: message,
			          type: 'warning'
			      });
			  }
			  this.loading = false
		  })
      },
  
      // 编辑角色
      handleTableMenus: function () {
          this.loading = true;
		  this.$api.management.roleMenusAdd(this.menusForm).then(res=>{
			  if (res.code === 0) {
			    
			      this.$message({
			          showClose: true,
			          message: '修改角色菜单权限信息成功！',
			          type: 'success'
			      });
				  this.menusFormVisiable = false;
			  } else {
			      var message = '修改角色菜单权限信息失败！';
			    
			      if (res.message) {
			          message = res.message;
			      }
			    
			      this.$notify({
			          showClose: true,
			          message: message,
			          type: 'warning'
			      });
			  }
			  this.loading = false
		  })
  
  
      },
  
      // 打开编辑角色弹窗
      handleTableActionsOpen: function (row) {
          this.loading = true;
		  this.$api.management.roleActions({id: row.id}).then(res=>{
			  if (res.code === 0) {
			      this.options.actions = res.data.actions;
			      this.actionsForm.privileges = res.data.privileges;
			      this.actionsForm.id = res.data.role.id;
			    
			      this.$message({
			          showClose: true,
			          message: '查询角色信息成功！',
			          type: 'success'
			      });
			      this.actionsFormVisiable = true;
			  } else {
			      var message = '查询角色信息失败！';
			    
			      if (res.message) {
			          message = res.message;
			      }
			    
			      this.$notify({
			          showClose: true,
			          message: message,
			          type: 'warning'
			      });
			  }
			  this.loading = false
		  })
      },
  
      // 编辑角色
      handleTableActions: function () {
  
          this.loading = true;
		  this.$api.management.roleActionsAdd(this.actionsForm).then(res=>{
			  if (res.code === 0) {
			    
			      this.$message({
			          showClose: true,
			          message: '修改角色信息成功！',
			          type: 'success'
			      });
				  this.actionsFormVisiable = false;
			  } else {
			      var message = '修改角色信息失败！';
			    
			      if (res.message) {
			          message = res.message;
			      }
			    
			      this.$notify({
			          showClose: true,
			          message: message,
			          type: 'warning'
			      });
			  }
			  this.loading = false
		  })
  
      },
  
      // 删除角色
      handleTableDelete: function (row) {
  
          this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(function () {
              this.loading = true;
			  this.$api.management.roleActionsDel({id: row.id}).then(res=>{
				  if (res.code === 0) {
				      var data = this.tableData.data;
				      data.forEach(function (item, index) {
				          if (item.id == row.id) {
				              this.$delete(data, index);
				          }
				      }.bind(this));
				    
				      this.$message({
				          showClose: true,
				          message: '删除角色信息成功！',
				          type: 'success'
				      });
				    
				  } else {
				      var message = '删除角色信息失败！';
				    
				      if (res.message) {
				          message = res.message;
				      }
				    
				      this.$notify({
				          showClose: true,
				          message: message,
				          type: 'warning'
				      });
				  }
				  this.loading = false
			  })
          }.bind(this))
      },
      // 生成查询参数
      makeParams: function (query) {
          var params = {};
          params['type'] = query.type ? query.type : this.resetSearch.type;
          params['name'] = query.name ? query.name : this.resetSearch.name;
          params['level'] = query.level ? query.level : this.resetSearch.level;
  
          this.searchForm = params;
          return params;
      }
  },
  mounted: function () {
      var params = this.makeParams(this.$route.query);
      this.handleSearch(params);
  },
  beforeRouteUpdate: function (to, from, next) {
      var params = this.makeParams(to.query);
      this.handleSearch(params);
      next();
  }
}
</script>